import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-idle-state',
  templateUrl: './idle-state.component.html',
  styleUrls: ['./idle-state.component.scss']
})

export class IdleStateComponent extends BaseComponent implements OnInit {

  imggif:any;

  ngOnInit(): void {
  	super.ngOnInit();

  	// if (this.localSession.isSocketConnected()) {
  	// 	console.log(this.localSession.getDeviceInfo());
  	// }
  	this.imggif ='/assets/img/Foster-Box-Animation-v04-04.gif?t=' + Date.now();
  }

}
